<template>
  <div class="auth-page">
    <b-container>
      <h5 class="auth-logo">
        <i class="fa fa-circle text-primary"></i>
        Ekhoni Daktar
        <i class="fa fa-circle text-danger"></i>
      </h5>
      <Widget class="widget-auth mx-auto" title="<h3 class='mt-0'>Login to Doctor Panel</h3>" customHeader>
        <p class="widget-auth-info">
          Use your mobile number to sign in.
        </p>
        <form class="mt" @submit.prevent="login">
          <b-alert class="alert-sm" variant="danger" :show="!!errorMessage">
            {{ errorMessage }}
          </b-alert>
          <div class="form-group">
            <b-form-input class="form-control no-border" v-model="login_form.mobile" ref="mobile" required type="tel"
                          name="mobile" placeholder="Phone Number"/>
          </div>

          <div class="form-group">
            <b-form-input class="form-control no-border" v-model="login_form.password" ref="password" required
                          type="password" name="password" placeholder="Password"/>
          </div>

          <b-button size="sm" class="auth-btn mb-3" variant="inverse"
                    @click="requestLogin">Login</b-button>
          <!--          <p class="widget-auth-info">or sign in with</p>-->
          <!--          <div class="social-buttons">-->
          <!--            <b-button variant="primary" class="social-button mb-2">-->
          <!--              <i class="social-icon social-google"></i>-->
          <!--              <p class="social-text">GOOGLE</p>-->
          <!--            </b-button>-->
          <!--            <b-button variant="success" class="social-button">-->
          <!--              <i class="social-icon social-microsoft"></i>-->
          <!--              <p class="social-text">MICROSOFT</p>-->
          <!--            </b-button>-->
          <!--          </div>-->
        </form>
        <p class="widget-auth-info">
          Don't have an account?
        </p>
        <div>
          <!--          <router-link  class="d-block text-center" :to="{name: 'doctorrequest'}">Send Join Request</router-link>-->
          <a class="d-block text-center" @click="showJoinRequestForm"> Send Join Request </a>

        </div>
      </Widget>
    </b-container>

    <b-modal ref="join-request" no-close-on-backdrop no-close-on-esc centered hide-footer title="Ekhoni Daktar">
      <Request></Request>
    </b-modal>

    <footer class="auth-footer">
      {{ new Date().getFullYear() }} &copy; Ekhoni Daktar.
    </footer>
  </div>
</template>

<script>
import Form from 'vform';

import AuthService from '@/services/doctor/auth.service';
import {mapGetters, mapActions} from 'vuex';
import Request from "@/pages/doctor/Login/Request";

export default {
  name: 'LoginPage',
  components: {
    Request
  },
  data() {
    return {
      errorMessage: null,
      otp_code_requested: false,
      login_form: new Form({
        mobile: '',
        otp_code: '',
        password: '',
        is_patient: false,
        device_id: '',
      }),
    };
  },
  computed: {
    ...mapGetters('doctorAuth', ['getUser']),

  },
  methods: {
    ...mapActions('doctorAuth', ['storeUser', 'setdoctortype']),
    requestLogin() {
      AuthService.login(this.login_form)
          .then((resposne) => {
            if (resposne.status === 200 || resposne.status === 201) {
              this.storeUser(resposne.data);
              this.$router.push('/doctor');
            }
          })
    },
    // getOtp() {
    //   AuthService.requestOTP(this.login_form)
    //       .then((response) => {
    //         if (response.status === 201) {
    //           this.otp_code_requested = true;
    //         }
    //       })
    //       .catch((e) => console.error(e))
    // },
    showJoinRequestForm() {
      this.$refs['join-request'].show();
    }
  },
  created() {
    if (this.getUser) {
      this.$router.push('/doctor');
    }
  },
  mounted() {
    AuthService.fetchDoctorTypes()
        .then((response) => {
          if (response.status === 200) {
            this.setdoctortype(response.data);
          }
        })
  }
};
</script>
